document.addEventListener("DOMContentLoaded", () => {
  const cursor = document.querySelector(".m-menu-drawer__cursor");
  const backdrop = document.querySelector(".m-menu-drawer__backdrop");
  const drawer = document.querySelector(".m-menu-drawer");

  if (!cursor || !backdrop) return;

  // Flyt cursoren efter musen
  document.addEventListener("mousemove", (e) => {
    const drawerIsOpen = drawer.classList.contains("open");
    if (!drawerIsOpen) return;

    cursor.style.left = e.clientX - 13 + "px";
    cursor.style.top = e.clientY - 13 + "px";

    // Kun synlig når man er UDENFOR draweren, dvs. på backdrop
    if (e.target === backdrop) {
      cursor.style.display = "flex";
    } else {
      cursor.style.display = "none";
    }
  });

  // 👇 NYT: sørg for at cursoren forsvinder når menuen lukker
  const hideCursor = () => {
    cursor.style.display = "none";
  };

  // Når draweren mister klassen .open → skjul cursor
  const observer = new MutationObserver(() => {
    if (!drawer.classList.contains("open")) {
      hideCursor();
    }
  });

  observer.observe(drawer, {
    attributes: true,
    attributeFilter: ["class"],
  });
});
